import { useState, useEffect } from "react";

import "./BasicInformation.scss";
import { Form, Input, Button, Progress, Tooltip } from "antd";
import type { FormInstance } from "antd";
import CustomInput from "../../../components/CustomInput/CustomInput";
import TagInput from "antd-tag-input";
import CustomButton from "../../../components/AccommodationData/CustomButton/CustomButton";

const BasicInformation = (props: any) => {
  const [form] = Form.useForm();
  const [value, setValue] = useState<string[]>([]);

  useEffect(() => {
    setValue(props?.data?.tags);
  }, [props]);

  const [inputData, setInputData] = useState<any>({});

  //const totalNumber = props?.data?.totalNumberOfRooms;

  const totalNumber = props?.data?.roomTypes?.reduce(
    (total: number, roomType: any) => total + roomType.totalNumber,
    0
  );

  const full = props?.data?.roomTypes?.reduce(
    (total: number, roomType: any) => total + roomType.usedNumber,
    0
  );

  const reserved = props?.data?.roomTypes?.reduce(
    (total: number, roomType: any) => total + roomType.reservedNumber,
    0
  );

  let free = totalNumber - (full + reserved);

  useEffect(() => {
    setInputData(props.data);
    form.setFieldsValue(props.data);
  }, [props.data]);

  const SubmitButton = ({ form }: { form: FormInstance }) => {
    const [submittable, setSubmittable] = useState(false);
    const values = Form.useWatch([], form);
    useEffect(() => {
      form.validateFields({ validateOnly: true }).then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
    }, [values]);

    return (
      <CustomButton
        danger={false}
        htmlType={"submit"}
        disabled={!submittable}
        type={"primary"}
        function={() => {
          saveAccommodation();
        }}
        text={"Izmeni"}
      />
    );
  };

  const saveAccommodation = () => {
    return;
  };

  return (
    <div className="basic-information">
      <Form
        form={form}
        name="basic-information-form"
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item name="name" label="Naziv smeštaja:">
          <Input className="input-label" placeholder="Unesite naziv smeštaja" />
        </Form.Item>
        <Form.Item name="address" label="Adresa smeštaja:">
          <Input
            className="input-label"
            placeholder="Unesite adresu smeštaja"
          />
        </Form.Item>
        <Form.Item name="webAddress" label="Email:">
          <Input className="input-label" placeholder="Unesite email" />
        </Form.Item>
        <Form.Item name="contactName" label="Kontakt osoba:">
          <Input className="input-label" placeholder="Unesite kontakt osobu" />
        </Form.Item>
        <Form.Item name="contactPhone" label="Kontakt telefon:">
          <Input
            className="input-label"
            placeholder="Unesite kontakt telefon"
          />
        </Form.Item>
        <Form.Item
          name="receptionContactPhone"
          label="Kontakt telefon recepcije:"
        >
          <Input
            className="input-label"
            placeholder="Unesite kontakt telefon recepcije"
          />
        </Form.Item>
        <Form.Item name="numberOfHalls" label="Broj sala za dogadjaje:">
          <Input
            type="number"
            className="input-label"
            placeholder="Unesite broj sala"
          />
        </Form.Item>
        <Form.Item name="hallCapacity" label="Kapacitet sale:">
          <Input
            type="number"
            className="input-label"
            placeholder="Unesite kapacitet sale"
          />
        </Form.Item>
        <Form.Item label="Tagovi smeštaja:" className="tags-acc">
          <TagInput
            value={value}
            placeholder="Unesite tagove za smeštaj"
            onChange={(strArr) => setValue(strArr)}
          />
        </Form.Item>
        <div className="form-box-total-room">
          <CustomInput
            label={"Ukupno soba:"}
            first={full}
            second={reserved}
            third={free}
          />
        </div>
        <Tooltip
          className="progress"
          title={`${full} Popunjeno / ${reserved} Rezervisano / ${free} Slobodno`}
        >
          <Progress
            percent={
              +(
                (reserved / (full + reserved + free)) * 100 +
                (full / (full + reserved + free)) * 100
              ).toFixed(2)
            }
            success={{ percent: (full / (full + reserved + free)) * 100 }}
          />
        </Tooltip>

        {props?.data?.roomTypes?.map((roomTypesForEvent: any) => {
          let totalNumber = roomTypesForEvent?.totalNumber;
          let Full = roomTypesForEvent?.usedNumber || 0; /// popunjeno
          let Reserved = roomTypesForEvent?.reservedNumber;
          let Free = totalNumber - (Full + Reserved);
          return (
            <div className="form-container">
              <div className="form-box-first-row">
                <CustomInput
                  label={`${roomTypesForEvent?.roomType?.name}`}
                  first={Full || 0}
                  second={Reserved || 0}
                  third={Free || 0}
                />
              </div>
              <Form.Item className={"form-box-second-row"} label="Sajt:">
                <Input
                  type="number"
                  className="input-label"
                  placeholder="Sajt:"
                  defaultValue={roomTypesForEvent?.totalNumberRoomForSite}
                />
              </Form.Item>
              <Form.Item className={"form-box-second-row"} label="Kapacitet:">
                <Input
                  type="number"
                  className="input-label"
                  placeholder="Kapacitet"
                  defaultValue={roomTypesForEvent?.roomType?.capacity}
                />
              </Form.Item>
            </div>
          );
        })}

        <Form.Item className="notes" name="note" label="Napomena:">
          <Input className="input-label" placeholder="Unesite napomenu" />
        </Form.Item>
        <Form.Item className="submit-container">
          <SubmitButton form={form} />
        </Form.Item>
      </Form>
    </div>
  );
};

export default BasicInformation;
